import React, { useContext, useState } from 'react'
import { motion, useMotionValue } from "framer-motion"

import avatar from "../assets/img/avatar.jpg"
import pizza from "../assets/img/pizza.svg"
import order from "../assets/icons/order.svg"
import arrow from "../assets/icons/arrow.svg"

import MyContext from './Context/Context'
import AuthContext from './Context/AuthContext'

function Basket() {
    const { menu, toggleMenu, basket, total, addToBasket, setFlashMessage } = useContext(MyContext);
    const { userProfile } = useContext(AuthContext);
    const x = useMotionValue(0);

    const handleMenu = () => {
        toggleMenu(!menu);
    }

    const variants = {
        open: {
            x: 0,
            transition: {
                duration : 0.35,
                ease: "easeIn"
            }
        },
        closed: {
            x: 300,
            transition: {
                duration : 0.35,
                ease: "easeOut"
            }
        },
    }

    const handleDrag = () => {
        if(x.current >= 100) {
            toggleMenu(true);
        }
    }

    const updateBasket = (item, method) => {
        addToBasket(item, method);
    }

    return (
        <motion.aside className="basket"
            variants={variants}
            animate={menu ? "closed" : "open" }
            drag={!menu ? "x" : false}
            x={x}
            dragConstraints={{ left: 0, right: 300 }}
            dragElastic={0}
            dragMomentum={false}
            onDrag={(e) => handleDrag(e)}
        >
            <div className="basket__wrapper">
            <div className="basket__toggle"
                onClick={handleMenu}
                data-counter={basket.length > 0 ? basket.length : "0"}
            >
                <span className={menu ? "close" : null}>
                    <img
                    src={arrow} alt="open menu"/>
                </span>
            </div>
            <div className="basket__profil">
                <img src={userProfile.avatar ? process.env.REACT_APP_URL_SERVER + userProfile.avatar : avatar} alt="avatar"/>
                <span>{userProfile.email ? userProfile.email : 'Unlogged Guest'}</span>
            </div>
            <h3 className="basket__title">Your order <span>summary</span></h3>
            <ul className="basket__list">
                {
                    basket.map((item, i) => (
                        <li key={i} className="basket__list__item">
                            <img src={pizza} alt="pizza"/>
                            <h4>{item.category} <span>{item.title}</span></h4>
                            <span>x</span>
                            <span className="quantity">
                                <button onClick={() => updateBasket(item, "add")}>+</button>
                                <span>{item.quantity}</span>
                                <button onClick={() => updateBasket(item, "remove")}>-</button>
                            </span>
                            <span className="price">${(item.price * item.quantity).toFixed(2)}</span>
                        </li>
                    ))
                }
            </ul>
            <div className="basket__delivery">
                <span>Free delivery</span>
                <span className="price">$0.00</span>
            </div>
            <hr className="basket__hr" />
            <div className="basket__total">
                <span>Total</span>
                <span className="price">${total}</span>
            </div>
            <h3 className="basket__title">Your delivery <span>address</span></h3>
            <div className="basket__adress">
                <img src={order} alt="order icon"/>
                {
                    userProfile.city && userProfile.street ? (
                        <span>{userProfile.city}, {userProfile.street} <br/> 📞{userProfile.phone}</span>
                    ) : (
                        <span>You are nor logged</span>
                    )
                }
                
            </div>
            <motion.button className="btn btn-primary"
                whileHover={{
                    scale: 1.1
                }}
            >
                <span>Checkout</span>
            </motion.button>
            </div>
        </motion.aside>
    )
}

export default Basket
